import ElementType from "../../../type/slate/ElementType";
import TextSize from "../../../type/slate/TextSize";
import TextStyleType from "../../../type/slate/TextStyleType";
import TextType from "../../../type/slate/TextType";

export const LIST_TYPES: ElementType[] = [ElementType.NUMBERED_LIST, ElementType.BULLETED_LIST];

export const REMOVABLE_TEXT_TYPES: string[] = [
  TextStyleType.COLOR,
  TextStyleType.FONT,
  TextType.BOLD,
  TextType.UNDERLINE,
  TextType.ITALIC,
  TextType.STRIKE,
];

export const INDENT_MAXIMUM = 3;

export const RESOURCE_LINK_ID_PREFIX = "resourceDownloadLink-";

export const RESOURCE_ID_DATA_ATTRIBUTE = "resourceId";

export const TEXT_SIZE_TO_FONT_SIZE: Readonly<Record<TextSize, number>> = {
  [TextSize.LARGE]: 20,
  [TextSize.MEDIUM]: 14,
  [TextSize.SMALL]: 12,
};
